/**
 * bootprompt.js locale configuration
 * locale : Czech
 * author : Lukáš Fryč
 */

import { addLocale } from "../bootprompt";

addLocale("cs", {
  OK: "OK",
  CANCEL: "Zrušit",
  CONFIRM : "Potvrdit",
});
